import app from '../../common/app'
import Login from './login-ruba'

app.bootstrap(Login);
